export default "__VITE_ASSET__DMOQTCmk__"